// This file is auto-generated by icons cli
module.exports = {
  'advice-check': require('./icons/advice-check.svg'),
  'advice-error': require('./icons/advice-error.svg'),
  'advice-info': require('./icons/advice-info.svg'),
  'advice-not-included': require('./icons/advice-not-included.svg'),
  'apple-podcast': require('./icons/apple-podcast.svg'),
  'arrow-chevron--type-down': require('./icons/arrow-chevron/type=down.svg'),
  'arrow-chevron--type-left': require('./icons/arrow-chevron/type=left.svg'),
  'arrow-chevron--type-right': require('./icons/arrow-chevron/type=right.svg'),
  'arrow-chevron--type-up': require('./icons/arrow-chevron/type=up.svg'),
  'arrow-corner--type-left-down': require('./icons/arrow-corner/type=left-down.svg'),
  'arrow-corner--type-left-up': require('./icons/arrow-corner/type=left-up.svg'),
  'arrow-corner--type-right-down': require('./icons/arrow-corner/type=right-down.svg'),
  'arrow-corner--type-right-up': require('./icons/arrow-corner/type=right-up.svg'),
  'arrow-cricle--type-down': require('./icons/arrow-cricle/type=down.svg'),
  'arrow-cricle--type-left-down': require('./icons/arrow-cricle/type=left-down.svg'),
  'arrow-cricle--type-left-up': require('./icons/arrow-cricle/type=left-up.svg'),
  'arrow-cricle--type-left': require('./icons/arrow-cricle/type=left.svg'),
  'arrow-cricle--type-right-down': require('./icons/arrow-cricle/type=right-down.svg'),
  'arrow-cricle--type-right-up': require('./icons/arrow-cricle/type=right-up.svg'),
  'arrow-cricle--type-right': require('./icons/arrow-cricle/type=right.svg'),
  'arrow-cricle--type-up': require('./icons/arrow-cricle/type=up.svg'),
  'arrow-direction--type-down': require('./icons/arrow-direction/type=down.svg'),
  'arrow-direction--type-left': require('./icons/arrow-direction/type=left.svg'),
  'arrow-direction--type-right': require('./icons/arrow-direction/type=right.svg'),
  'arrow-direction--type-up': require('./icons/arrow-direction/type=up.svg'),
  'brand-asset': require('./icons/brand-asset.svg'),
  'brand-green-2': require('./icons/brand-green-2.svg'),
  'brand-isotype': require('./icons/brand-isotype.svg'),
  'brand-logo': require('./icons/brand-logo.svg'),
  'check': require('./icons/check.svg'),
  'divider': require('./icons/divider.svg'),
  'email': require('./icons/email.svg'),
  'eye--type-off': require('./icons/eye/type=off.svg'),
  'eye--type-on': require('./icons/eye/type=on.svg'),
  'g2': require('./icons/g2.svg'),
  'instagram': require('./icons/instagram.svg'),
  'ivoox': require('./icons/ivoox.svg'),
  'link': require('./icons/link.svg'),
  'linkedin': require('./icons/linkedin.svg'),
  'location': require('./icons/location.svg'),
  'menu': require('./icons/menu.svg'),
  'minus': require('./icons/minus.svg'),
  'pause--filled-off': require('./icons/pause/filled=off.svg'),
  'pause--filled-on': require('./icons/pause/filled=on.svg'),
  'play--filled-off': require('./icons/play/filled=off.svg'),
  'play--filled-on': require('./icons/play/filled=on.svg'),
  'plus': require('./icons/plus.svg'),
  'search': require('./icons/search.svg'),
  'spotify': require('./icons/spotify.svg'),
  'star--type-empty': require('./icons/star/type=empty.svg'),
  'star--type-filled': require('./icons/star/type=filled.svg'),
  'star--type-half': require('./icons/star/type=half.svg'),
  'twitter': require('./icons/twitter.svg'),
  'user': require('./icons/user.svg'),
  'x': require('./icons/x.svg'),
  'youtube': require('./icons/youtube.svg'),
}
